export default __webpack_public_path__ + "static/media/ic_mozambique.988bdbfb.svg";